import { useContext } from "react";
import {
  MxFileDraggableContext,
  MxFileDropzoneContextReturn
} from "../MxFileDraggable";

export const useMxFileDraggable = () => {
  const context = useContext(MxFileDraggableContext);
  if (!context) {
    throw new Error(
      "useMxFileDraggable must be used within a MxFileDraggableProvider"
    );
  }
  return context as unknown as MxFileDropzoneContextReturn;
};
